import React from 'react';

/**
 * Premium Logo Component — Teal-to-Blue Identity
 * Brand text 'espacero' must NOT be changed.
 */
export const Logo: React.FC<{ size?: 'sm' | 'md' | 'lg' | 'xl'; dark?: boolean }> = ({ size = 'md', dark = false }) => {
    const sizeClasses = {
        sm: { box: 'w-6 h-6 rounded-md', icon: 14, text: 'text-sm' },
        md: { box: 'w-8 h-8 rounded-lg', icon: 18, text: 'text-lg' },
        lg: { box: 'w-10 h-10 rounded-xl', icon: 24, text: 'text-xl' },
        xl: { box: 'w-12 h-12 rounded-xl', icon: 28, text: 'text-2xl' },
    };

    const s = sizeClasses[size];

    return (
        <div className="flex items-center gap-2.5 select-none">
            {/* Icon mark — blue gradient cube */}
            <div className={`relative ${s.box} flex items-center justify-center ${dark ? 'bg-white shadow-md' : 'bg-gradient-to-r from-sky-400 to-blue-600 shadow-lg shadow-blue-500/20'}`}>
                <svg width={s.icon} height={s.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="text-white">
                    {/* Isometric Cube – top face */}
                    <path d="M12 2L20.66 7L12 12L3.34 7L12 2Z" fill="currentColor" fillOpacity="1" />
                    {/* Left face */}
                    <path d="M3.34 7L12 12V22L3.34 17V7Z" fill="currentColor" fillOpacity="0.5" />
                    {/* Right face */}
                    <path d="M12 12L20.66 7V17L12 22V12Z" fill="currentColor" fillOpacity="0.75" />
                </svg>
            </div>
            <div className="flex flex-col">
                <span translate="no" className={`notranslate font-extrabold ${s.text} ${dark ? 'text-white' : 'text-primary dark:text-stone-100'} tracking-tight leading-none`}>
                    espacero
                </span>
            </div>
        </div>
    );
};
